import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  background-color: ${theme.colors.green1};
  padding: 20px 16px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 50px 100px;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: ${theme.colors.white};
`

export const Title = styled.div`
  font-weight: ${theme.font.bold};
  font-size: ${theme.font.sizes.normal};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.xxlarge};
  }
`

export const Subtitle = styled.div`
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.small};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.large};
  }
`

export const CardList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
  }
`
